import React from 'react';

// import configs from './../../config'
import {Link} from "react-router-dom";


const TeacherCard = props => {
 const setTeacher = teacher => () => props.setTeacher(teacher);
  return (
    <div className="container">
      <div className="row">
        <div className="col-xl-10 col-lg-10 col-md-10 col-sm-12">
          <div className="our-services-wrapper m-60">
            <div className="services-inner">
              <div className="mob-name">
                <h4>{props.teacher.name}</h4>
              </div>
              <div className="our-services-img">
                <img src={props.teacher.imgLink} alt="" />
              </div>
              <div className="our-services-text">
                <h4>{props.teacher.name}</h4>
                <h3 className="nbsp"><br/>&nbsp;</h3>
                <div className="short-description">
                  <p>{props.teacher.shortDescription}</p>
                </div>
              </div>
              <div  className="choose-btn">
                <Link on to={'/teacher'} >
                  <div className="btn-inner" onClick={setTeacher(props.teacher)}  ><span>Ընտրել</span></div>
                </Link>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>


  )



};

export default TeacherCard;
